import { DayOfTheWeek } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

export const DAY_OF_THE_WEEK_LIST = [
	{ id: "日曜日", label: "日曜日", value: DayOfTheWeek.Sun },
	{ id: "月曜日", label: "月曜日", value: DayOfTheWeek.Mon },
	{ id: "火曜日", label: "火曜日", value: DayOfTheWeek.Tue },
	{ id: "水曜日", label: "水曜日", value: DayOfTheWeek.Wed },
	{ id: "木曜日", label: "木曜日", value: DayOfTheWeek.Thu },
	{ id: "金曜日", label: "金曜日", value: DayOfTheWeek.Fri },
	{ id: "土曜日", label: "土曜日", value: DayOfTheWeek.Sat },
] satisfies FormOptionType[];
